import service from "../service";

export interface DeviceReadingDatasetListParams {
  page?: number;
  key?: string;
  intPageSize?: number;
}

export interface ReadingValue {
  title?: string;
  value?: string | number;
  [key: string]: any;
}

export interface DeviceReadingDatasetItem {
  Id?: string | number;
  文件名?: string;
  上传时间?: string;
  AI读数json?: string;
  AI读数?: ReadingValue[] | string;
  实际读数?: ReadingValue[] | string;
  实际读数json?: string;
  AI读数状态?: string;
  上传人ID?: string;
  [key: string]: any;
}

export default {
  list(params: DeviceReadingDatasetListParams = {}, data: any[] = []): Promise<any> {
    return service({
      method: "POST",
      url: "/设备读数数据集/列表查询",
      params: {
        page: params.page || 1,
        key: params.key || "",
        intPageSize: params.intPageSize || 50,
      },
      data,
    });
  },
};
